import React, { ReactNode, MouseEvent, KeyboardEvent } from "react";
import cn from "classnames";
import styles from "./button-with-icon.module.scss";
import { ToolTip } from "@components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";

interface ButtonWithIconPropTypes {
  fun: (e?: MouseEvent | KeyboardEvent) => void;
  icon: string;
  text: string | ReactNode;
  type?: "button" | "submit" | "reset";
  variant?: string | string[];
  tooltip?: string;
  disabled?: boolean;
  disabledAppearance?: "sse";
}

export const ButtonWithIcon = ({
  fun,
  icon,
  text,
  type = "submit",
  variant,
  tooltip = "",
  disabled = false,
  disabledAppearance,
}: ButtonWithIconPropTypes) => {
  const i18n = useI18N();
  let variantClass = "";

  const texts = {
    buttonWithIconAltText: i18n("modules.buttonWithIcon.buttonWithIconAltText"),
  };

  if (typeof variant === "string") {
    variantClass = styles[`button-with-icon--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant
      .map((v) => styles[`button-with-icon--${v}`])
      .join(" ");
  }

  const button = (
    <button
      type={type}
      onClick={fun}
      className={cn(styles["button-with-icon"], variantClass, {
        [styles["button-with-icon--disabled"]]: disabled,
        [styles["button-with-icon--disabled-sse"]]:
          disabled && disabledAppearance === "sse",
      })}
      disabled={disabled}
    >
      <img
        className={styles["button-with-icon__icon"]}
        src={icon}
        alt={texts.buttonWithIconAltText}
      />
      {text}
    </button>
  );

  return tooltip ? <ToolTip content={tooltip}>{button}</ToolTip> : button;
};
